<template>
  <tr class="video-upload-list-item">
    <td class="first-td">
      <div
        v-tooltip="{
          content: videoStatusDetails.isNotReady
            ? videoStatusDetails.tooltip
            : '',
        }"
        class="selection-wrapper pointer"
        @click="selectVideo"
      >
        <v-radio :disabled="videoStatusDetails.isNotReady" :value="item.id">
        </v-radio>
        <img
          class="video-thumbnail"
          :src="thumbnailSrc"
          alt="video-thumbnail"
        />
      </div>
    </td>

    <td>
      <div class="flex-col">
        {{ item.name }}
        <div v-if="item.status === 'ready'" class="flex duration-info-wrapper">
          <span>Duração: {{ formattedDuration }}</span>
        </div>
        <div v-else class="duration-info-wrapper">
          <span>{{ videoStatusDetails.statusDescription }}</span>
        </div>
      </div>
    </td>

    <td>
      {{ uploadDate }}
    </td>

    <td>
      <div class="actions-wrapper">
        <button>
          <i
            v-tooltip="'Deletar'"
            class="mdi mdi-delete"
            @click="showConfirmationModal"
          ></i>
        </button>
        <button v-if="item.status === 'ready'">
          <i
            v-tooltip="'Preview'"
            class="mdi mdi-play"
            @click="previewVideo"
          ></i>
        </button>
      </div>
    </td>

    <confirmation-modal
      :value="showingConfirmationModal"
      :confirm-label="$t('message.generics.message.confirm')"
      @confirm="deleteVideo"
      @cancel="closeConfirmationModal"
    >
      <span slot="heading"> Deletar vídeo </span>
      <span> Quer mesmo deletar este vídeo? Esta ação é irreversível </span>
    </confirmation-modal>

    <video-preview-modal
      v-if="showingPreviewModal"
      v-model="showingPreviewModal"
      :video-url="item.videoUrl"
      :video-id="item.id"
    ></video-preview-modal>
  </tr>
</template>

<script>
import EventBus from "@packages/event-bus";
import ConfirmationModal from "@components/ConfirmationModal.vue";
import VideoPreviewModal from "../../preview-modal/VideoPreviewModal.vue";

export default {
  components: {
    ConfirmationModal,
    VideoPreviewModal,
  },

  data() {
    return {
      showingConfirmationModal: false,
      showingPreviewModal: false,
    };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    uploadDate() {
      return this.$date.format(this.item.creationDate);
    },
    messageModalData() {
      return this.messageModalType === "content"
        ? this.item.content
        : this.item.causeError;
    },
    thumbnailSrc() {
      return (
        (this.item.status === "ready" && this.item.thumbnailUrl) ||
        require("@assets/images/undefined-video.png")
      );
    },
    videoStatusDetails() {
      const status = this.item.status;

      return {
        isNotReady: status !== "ready",
        tooltip:
          status === "error"
            ? "Não é possível selecionar vídeos com erro"
            : "Não é possível selecionar vídeos em progresso",
        statusDescription:
          status === "error" ? "Erro no upload" : "Em progresso...",
      };
    },
    formattedDuration() {
      const durationInSeconds = this.item.duration;
      const minutes = Math.floor(durationInSeconds / 60);
      const seconds = durationInSeconds % 60;
      return minutes > 0
        ? `${minutes} min ${seconds} s`
        : `${seconds} segundos`;
    },
  },

  methods: {
    async deleteVideo() {
      EventBus.$emit("SHOW_SPINNER");
      try {
        await this.$api.video.delete(this.item.id);
        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Vídeo deletado com sucesso",
        });
        this.$emit("on-deleted");
      } catch (error) {
        console.log(error);
      } finally {
        this.closeConfirmationModal();
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    previewVideo() {
      this.showingPreviewModal = true;
    },
    showConfirmationModal() {
      this.showingConfirmationModal = true;
    },
    closeConfirmationModal() {
      this.showingConfirmationModal = false;
    },
    selectVideo() {
      if (this.videoStatusDetails.isNotReady) return;
      this.$emit("on-selected", this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-upload-list-item {
  td {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  .first-td {
    padding-left: 0;
    padding-right: 0;

    .selection-wrapper {
      display: flex;
      gap: 4px;

      .v-radio {
        margin-right: 0;
      }

      .video-thumbnail {
        width: 130px;
      }
    }
  }
  .duration-info-wrapper {
    font-size: 12px;
  }
  .actions-wrapper {
    display: flex;
    gap: 4px;

    .mdi {
      font-size: 20px;
    }
  }
}
</style>
